import getTradingCompanyName from '../../utils/getTradingCompanyName';
import type { ValueGetterParams } from 'ag-grid-community';
import type { OptionsType } from '../../types/options';
import type { Language, SelectOption, SteelMaker } from '../../types/common';
import { OrganizationUserType } from '../../types/user';

/**
 * steelMaker[]からフィルタ用の文字列を生成する。
 * contextにcurrentLang, steelMakerが存在する必要がある。
 * 解決できなかった場合はvalueをstringとして返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const tradingCompanyFilterValueGetter = (params: ValueGetterParams) => {
  const tradingCompanyCodes: string[] = params.getValue('tradingCompany');
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const tradingCompany: OptionsType<SteelMaker>[] | undefined = params.context?.tradingCompany;
  // 商社コードの配列を商社名の配列にマップする。マッチするものが見つからなかったらコードのままにする。
  const tradingCompanyNames: string[] = tradingCompanyCodes.map((code) => {
    const tradingCompanyName: string = getTradingCompanyName(code, { tradingCompanies: tradingCompany, language: currentLang.value });
    return tradingCompanyName;
  });
  const filterValue = tradingCompanyNames.join(', ');
  return filterValue;
};

export default tradingCompanyFilterValueGetter;
